import { buildBusinessTypeIconCDNAssetUrl } from "@repo/utils/lib/url";
import type { SVGProps } from "react";

export type CdnBusinessTypeIconVariant = "default" | "invert" | "muted";

type CdnBusinessTypeIconProps = SVGProps<SVGSVGElement> & {
  iconName: string;
  variant?: CdnBusinessTypeIconVariant;
};

export function CdnBusinessTypeIcon({
  iconName,
  variant = "default",
  ...props
}: CdnBusinessTypeIconProps) {
  const url = buildBusinessTypeIconCDNAssetUrl(iconName);

  return (
    <>
      {/* biome-ignore lint/performance/noImgElement: native img needed for CDN icon with onError fallback */}
      <img
        src={url}
        alt={iconName}
        width={props.width}
        height={props.height}
        className={props.className}
        style={{
          ...props.style,
          filter:
            variant === "invert"
              ? "invert(1)"
              : variant === "muted"
                ? "invert(54%) sepia(0%) saturate(182%) hue-rotate(144deg) brightness(101%) contrast(72%)"
                : undefined,
        }}
      />
    </>
  );
}
